/* tslint:disable */
/* eslint-disable */
/**
 * Generali TechEx Services API
 *  Generali TechEx Services Python API. ## References * [Pricing Tools](https://gptdoc.etractive.de/build/design-pfm/) * [Excel Add-In](https://gptdoc.etractive.de/build/ms365/) 
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: info@techex.generali.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Enum for column data types, matching the TypeScript enum.
 * @export
 */
export const FormulaEvaluateColumnDataType = {
    String: 'string',
    Number: 'number',
    Date: 'date',
    Datetime: 'datetime',
    Boolean: 'boolean',
    Default: 'default',
} as const;
export type FormulaEvaluateColumnDataType = typeof FormulaEvaluateColumnDataType[keyof typeof FormulaEvaluateColumnDataType];


export function instanceOfFormulaEvaluateColumnDataType(value: any): boolean {
    for (const key in FormulaEvaluateColumnDataType) {
        if (Object.prototype.hasOwnProperty.call(FormulaEvaluateColumnDataType, key)) {
            if (FormulaEvaluateColumnDataType[key as keyof typeof FormulaEvaluateColumnDataType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function FormulaEvaluateColumnDataTypeFromJSON(json: any): FormulaEvaluateColumnDataType {
    return FormulaEvaluateColumnDataTypeFromJSONTyped(json, false);
}

export function FormulaEvaluateColumnDataTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): FormulaEvaluateColumnDataType {
    return json as FormulaEvaluateColumnDataType;
}

export function FormulaEvaluateColumnDataTypeToJSON(value?: FormulaEvaluateColumnDataType | null): any {
    return value as any;
}

export function FormulaEvaluateColumnDataTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): FormulaEvaluateColumnDataType {
    return value as FormulaEvaluateColumnDataType;
}

